export const DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const COLLECTION_METHODS = {
  STANDARD: 'standard',
  ALL_DAY: '24h',
  NO_COLLECTION: 'no_collection'
};

export const POSTAL_REGIONS = ['England', 'Wales', 'Scotland', 'Northern Ireland'];

export const SHORT_DAYS_MAP = {
  Sun: 'sunday',
  Mon: 'monday',
  Tue: 'tuesday',
  Wed: 'wednesday',
  Thu: 'thursday',
  Fri: 'friday',
  Sat: 'saturday'
};

export const MOBILE_PAYMENT_METHOD_CODE = 4;
